import React from 'react';
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'mdbreact/dist/css/mdb.css';
import './Components/setupAxios';

import { BrowserRouter as Router } from "react-router-dom";
import Routes from './Routes';
import LoadingOverlay from './Components/LoadingOverlay';

function App() {
  return (
    <div>
      <Router>
        <Routes />
      </Router>
      <LoadingOverlay />
    </div>
  );
}

export default App;

